export const Props = () => ({
  //ID сигнала
  signal: {
    type: Object,
    required: true,
  }
});